import type { FaireProductEntity } from "../../entity_types/product";

export const p_9h9fzwygjn: FaireProductEntity = {
  token: "p_9h9fzwygjn",
  type: "product",
  name: "Minimalist Silver Plated Wrap Ring",
  brandToken: "b_y2j497tv82",
  brandName: "The Pretty Jewellery",
  imageUrl:
    "https://cdn.faire.com/fastly/9527a811c090aec90147bb27ac1fb51eba912cceebad7df942c7a00fe914355f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9ee4bee28cf25c7e7cbe242e3d0b6aacecfbdc90d36e72d8507a187a70a9b73c.jpeg",
    "https://cdn.faire.com/fastly/5f4c91211e283e7f298215388c6fd194635a3158d1db18c2b494f8a1a723efe0.jpeg",
  ],
  priceDollars: 3.74,
  description:
    "Fashion and minimalist\n\nHierarchical wrap design\n\nSilver plating\n\nInner diameter 1.7CM\n\nWidth 1.6CM",
  tags: [],
  msrpDollars: 8.31,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:58.870Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
